/**
 * "Catalog & capabilities" — Dashboard section (ADR-0074).
 * Reconciled from apps/web catalog list + capability-detail editor (6 tabs).
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_CATALOG_PAGE: DocPageContent = {
  slug: 'dashboard/catalog',
  titleKey: 'docs.dashboard.catalog.title',
  descriptionKey: 'docs.dashboard.catalog.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.catalog.lead' },

    { kind: 'heading', level: 2, id: 'browse', textKey: 'docs.dashboard.catalog.browse.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.catalog.browse.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'walkthrough',
      textKey: 'docs.dashboard.catalog.walkthrough.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.catalog.walkthrough.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.dashboard.catalog.walkthrough.step.open.title',
          textKey: 'docs.dashboard.catalog.walkthrough.step.open.text',
        },
        {
          titleKey: 'docs.dashboard.catalog.walkthrough.step.describe.title',
          textKey: 'docs.dashboard.catalog.walkthrough.step.describe.text',
        },
        {
          titleKey: 'docs.dashboard.catalog.walkthrough.step.risk.title',
          textKey: 'docs.dashboard.catalog.walkthrough.step.risk.text',
        },
        {
          titleKey: 'docs.dashboard.catalog.walkthrough.step.activate.title',
          textKey: 'docs.dashboard.catalog.walkthrough.step.activate.text',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'editor', textKey: 'docs.dashboard.catalog.editor.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.catalog.editor.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.catalog.tab.general',
        'docs.dashboard.catalog.tab.permissions',
        'docs.dashboard.catalog.tab.schema',
        'docs.dashboard.catalog.tab.prompt',
        'docs.dashboard.catalog.tab.risk',
        'docs.dashboard.catalog.tab.audit',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'autosave',
      textKey: 'docs.dashboard.catalog.autosave.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.catalog.autosave.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.catalog.next.endpoints.title',
          textKey: 'docs.dashboard.catalog.next.endpoints.text',
          to: { docSlug: 'dashboard/custom-endpoints' },
        },
        {
          titleKey: 'docs.dashboard.catalog.next.concept.title',
          textKey: 'docs.dashboard.catalog.next.concept.text',
          to: { docSlug: 'catalog' },
        },
      ],
    },
  ],
};
